import { Avatar, Button, Card, Col, Row, Space, Typography, Upload, UploadFile, UploadProps } from 'antd';
import Paragraph from "antd/es/typography/Paragraph";
import React, { useState } from 'react';
import { getProperDate } from "utils/date";
import { CustomComment } from "./custom-comment";
import FileTag from "components/files/file-tag";
import SecondaryTextButton from "components/buttons/secondary-text-button";
import { Input } from 'antd';
import useToastContext from '../../hooks/useToastContext';
import usePatchRequest from '../../hooks/utils/usePatchRequest';
import { validateStatus } from '../../utils/utils';
import config from 'config';
import useGetRequestUpgrade from '../../hooks/utils/useGetRequestUpgrade';

const { Text } = Typography;
const { TextArea } = Input;

const PrepaidComment = ({ claimId, comment, isOwner }: { claimId: string, comment: CustomComment, isOwner: boolean }) => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [value, setValue] = useState(comment.text);
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const toast = useToastContext();
  const { patchError, patchLoading, executePatch } = usePatchRequest({ path:  `v1/claims/${claimId}/comments/${comment?.id}` });
  const { getData: file, getLoading: loadingFile, executeGet: executeGetFile } = useGetRequestUpgrade({ path : `v2/exporter/files?process=CLAIMS_TYPE`, manual: true });

  const props: UploadProps = {
    name: 'file',
    showUploadList: false,
    beforeUpload: (file) => {
      setFileList([...fileList, file]);

      return false;
    },
    fileList,
  };

  // Handle file upload changes
  const handleChange = ({ fileList: newFileList }: { fileList: UploadFile[] }) => {
      setFileList(newFileList);
  };

  const handleRemoveAttachment = ({ tag }: { tag: string}) => {
      console.log("Remove tag: " + tag)
  };

  const handleGetFile = async (file: string) => {
    const response = await executeGetFile( { url: config.api.url + `/v2/exporter/files?name=${file}&process=CLAIMS_LOAD` });

    if(response?.status === 200 || response?.status === 204) {
      toast.success('Exito', 'Descarga satisfactoria!.');
      // @ts-ignore
      window.open(response?.data?.url);
    }else {
      toast.error('Error', 'Ocurrió un problema al descargar, porfavor, intenta nuevamente.')
    }
  };

  const handleSaveComment = async () => {
    try {
      const response = await executePatch({ data: [{
          op: "replace",
          path: "/comment",
          value: value
        }]
      });

      if (validateStatus(response?.status)) {
        toast.success("Éxito" ,"Comentario modificado correctamente!");
        comment.text = value;
        setIsEditMode(!isEditMode);
      } else {
        toast.success("Error" ,"No se pudo editar el comentario");
      }

    } catch (e: unknown) {
      toast.error('Error', `Ocurrió un error: ${patchError}, porfavor, intenta nuevamente.`);
    }
  }

  return (
    <Card
      variant="borderless"
      style={{
        boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
        transform: "translateY(-2px)",
        transition: "all 0.3s ease",
        width: '100%'
      }}
    >
    <Row>
        <Col span="1" style={{ textAlign: 'center'}}>
            <Avatar style={{ backgroundColor: '#a368fc', verticalAlign: 'middle' }}>
                {comment.user.charAt(0).toUpperCase()}
            </Avatar>
        </Col>

        <Col flex="auto" style={{paddingLeft: '0.5em'}}>
            <Row>
                <Col span="10" style={{ textAlign: 'left'}}>
                    <Text type="secondary" strong> {comment.user.toUpperCase()} </Text>
                    <Text disabled style={{marginLeft: '0.1em'}}> { getProperDate(comment?.lastUpdate)} </Text>
                    { comment?.lastUpdate !== comment?.createdDate && (
                        <Text disabled style={{marginLeft: '0.1em'}}> Editado </Text>
                    )}
                </Col>
            </Row>

            { isEditMode ? (
                <>
                     <TextArea
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                        autoSize={{ minRows: 3 , maxRows: 6 }}
                    />

                {comment?.attachments_file_names?.length > 0 && (
                    <div style={{ marginBottom: '0.3em' }}>
                    <div style={{ display: "flex", gap: "10px", marginTop: "5px" }}>
                        <Text type="secondary">Adjuntos:</Text>
                        {comment.attachments_file_names.map((file) => (
                        <a style={{ textAlign: "center" }}>
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                <FileTag name={file} closeable={isEditMode} onClose={(tag) => handleRemoveAttachment({ tag })}/>
                            </div>
                        </a>
                        ))}
                    </div>
                    </div>
                 )}

                  <Space style={{marginTop:'1em', display: "flex", justifyContent: "flex-end", width: '100%'}}>
                      <Button danger onClick={()=>{setIsEditMode(false)}}>
                          Cancelar
                      </Button>

                      <Button type="primary" onClick={ handleSaveComment } style={{ marginRight: '10px' }}>
                          Guardar
                      </Button>
                  </Space>
                </>
            ): (
              <>
                <Paragraph style={{fontSize: '1.3em', marginBottom: '0.3em'}}>
                    {comment.text}
                </Paragraph>
                {comment?.attachments_file_names?.length > 0 && (
                  <div style={{ marginBottom: '0.3em' }}>
                    <div style={{ display: "flex", gap: "10px", marginTop: "5px" }}>
                        <Text type="secondary">Adjuntos:</Text>
                        {comment?.attachments_file_names?.map((file) => (
                        <a key={file} onClick={() => handleGetFile(file)} rel="noopener noreferrer" style={{ textAlign: "center" }}>
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                <FileTag name={file}/>
                            </div>
                        </a>
                        ))}
                    </div>
                  </div>
                 )}
                { isOwner && <SecondaryTextButton text='Editar' onClick={() => { setIsEditMode(true)}} /> }
              </>
            )}
        </Col>
    </Row>
    </Card>
  )};

export default PrepaidComment